import { type ReadonlyURLSearchParams } from "next/navigation";
import qs from "qs";
import { filterAllowedSearchParams } from "@/components/site-builder/modules/IframeModule/utils/filterAllowedSearchParams";
import { addSearchParamsToURL } from "@/utils/url/addSearchParamsToURL";

export function createIFrameURL(url: string, params: ReadonlyURLSearchParams) {
  const parsedSearchParams = qs.parse(params.toString());

  return addSearchParamsToURL(
    url,
    filterAllowedSearchParams(parsedSearchParams),
  );
}
